<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">Delete Customer</h1>
    <div class="modal-description">
      <p class="warning-text">
        Are you sure you want to delete
        <strong class="customer-name-highlight">'{{ data.customerName }}'</strong>?
        This action cannot be undone.
      </p>
      <div class="customer-detail">
        <ul>
          <li>
            <span class="detail-label">Customer ID:</span>
            <span class="detail-value">{{ data.customerId }}</span>
          </li>
          <li>
            <span class="detail-label">Customer Name:</span>
            <span class="detail-value">{{ data.customerName || 'N/A' }}</span>
          </li>
          <li *ngIf="data.accountNumber">
            <span class="detail-label">Account #:</span>
            <span class="detail-value">{{ data.accountNumber }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-container">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-delete" (click)="onConfirm()">Yes, Delete</button>
    </div>
  </div>
</div>
